import { combineReducers } from '@reduxjs/toolkit'
import { useSelector, useDispatch } from 'react-redux'
import state from './stateSlice'
import data from './dataSlice'

const reducer = combineReducers({
    data,
    state,
})

export * from './dataSlice'
export * from './stateSlice'
export { useSelector as useAppSelector, useDispatch as useAppDispatch }
export default reducer 